export var listItemEndMediaStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    return Object.assign({
      flexShrink: 0
    }, (p.selectable || p.navigable) && {
      display: 'none'
    });
  }
};